module.exports = __webpack_public_path__ + "img/宣传_150.dbfddc53.jpg";